import React from 'react';
import { APP_ROUTES } from '@/navigators/routes';
import { DrawerItem } from '@react-navigation/drawer';
import { DrawerLabel } from './drawer-label';
import { MORE_MENU_ABSORBED_ROUTES } from './more-menu/more-menu-absorbed-routes';
import { RouteMapType, useSideNavPress } from '@/hooks/use-side-nav-press';
import { StyleProp, ViewStyle } from 'react-native';
import { useLinkBuilder } from '@react-navigation/native';
import { useTheme } from '@/contexts/theme-context';

interface Props {
  activeIndex: number;
  itemStyle?: StyleProp<ViewStyle>;
  onClose: () => void;
  routes: RouteMapType[];
}

export const DrawerItemList: React.FC<Props> = ({
  activeIndex,
  itemStyle,
  onClose,
  routes,
}) => {
  const buildLink = useLinkBuilder();
  const theme = useTheme();
  const onSideNavPress = useSideNavPress();

  return routes.map(({ route, index }) => {
    const focused = index === activeIndex;
    const onPress = () => {
      onSideNavPress(route.name as APP_ROUTES, focused);
      onClose();
    };
    // Routes absorbed into the More menu popup (external content links,
    // storefront microproducts) render nothing here — see drawer-content.tsx.
    if (MORE_MENU_ABSORBED_ROUTES.has(route.name)) {
      return null;
    }

    return (
      <DrawerItem
        activeBackgroundColor={theme.colors.accent}
        focused={focused}
        inactiveBackgroundColor={theme.colors.transparent}
        key={route.key}
        label={() => <DrawerLabel focused={focused} name={route.name} />}
        onPress={onPress}
        style={itemStyle}
        to={buildLink(route.name, route.params)}
      />
    );
  });
};
